import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';

import React from 'react';
import { Link } from 'react-router-dom';
import style from './style.module.less';
import { Text, TextType } from 'ui-components/components/text';
import messages from '../messages';

export const LinkToAddOnMarketplace = () => {
  return (
    <Link className={style['link-to-add-on-marketplace']} to='/settings/addonmarketplace'>
      <Text textType={TextType.Paragraph} value={messages.linkToAddOns} />
      <FontAwesomeIcon className={style['link-right-arrow']} icon={faArrowRight} />
    </Link>
  );
};
